import React, { useCallback, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import FormField from '../../components/FormField'
import { isNaturalDocumentNumber, cpfMask, isDate, isName, dateMask, nameMask, formatName, formatToYYYYMMDD } from '../../utils/utils'
import useInput from '../../utils/hooks/useInput'
import { ErrorDialog } from './ErrorDialog'
import { v4 as uuidv4 } from 'uuid'
import { LocationDialog } from './LocationDialog'
import * as S from './styles'
import { useCookies } from 'react-cookie'
import ClientLogo from '../../components/ClientLogo'
import PoweredbByQITech from '../../components/PoweredByQITech'
import { Wallpaper } from '../../components/Wallpaper'
import { Footer } from '../../components/Footer'
import { Button } from '../../components'
import Logo from '../../components/Logo'
import { ThemedButton } from '../../components/ThemedButton'
import { LoadingPage } from '../LoadingPage'
import { useThemeContext } from "../../contexts/ThemeContext";
import { getOrCreateBrowserKey } from '../../utils/fingerprint_utils'

export const Login = (props) => {

    const { clientThemeSettings } = useThemeContext();
    
    const { setSignData, onSendOTPCode, setSignerStep, signData, setCachedDocumentNumber, setCachedBirthdate, appTheme } = props
    const { signerHash } = useParams()
    const [cookies, setCookie] = useCookies([`qisign_${signerHash}`])
    const hasMadeRequestRef = useRef(false)
    const [termsCheckboxChecked, setTermsCheckboxChecked] = useState(false)
    const [loading, setLoading] = useState(() => {
        const params = new URLSearchParams(window.location.search)
        return Boolean(params.get('document_number') || params.get('login_hash'))
    })
    const [loadingForm, setLoadingForm] = useState(false)

    const [isValidData, setValidData] = useState(false)
    const handleTermsCheckboxChange = (event) => {
        setTermsCheckboxChecked(event.target.checked)
        isValidInputData(event.target.checked)
    }

    let fields = {
        document_number: {
            id: "document_number",
            name: "Número do CPF",
            errorMessage: "Número de CPF inválido.",
        },
        birthdate: {
            id: "birthdate",
            name: "Data de Nascimento (DD/MM/AAAA)",
            errorMessage: "Data de nascimento inválida."
        },
        name: {
            id: "name",
            name: "Nome completo",
            errorMessage: "Nome completo inválido."
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            executeSubmission()
        }
    }

    const {
        value: documentNumberValue,
        isValid: documentNumberIsValid,
        hasError: documentNumberHasError,
        valueChangeHandler: documentNumberValueChangeHandler,
        inputBlurHandler: documentNumberInputBlurHandler,
        reset: documentNumberReset
    } = useInput(isNaturalDocumentNumber)

    const {
        value: birthdateValue,
        isValid: birthdateIsValid,
        hasError: birthdateHasError,
        valueChangeHandler: birthdateValueChangeHandler,
        inputBlurHandler: birthdateInputBlurHandler,
        reset: birthdateReset
    } = useInput(isDate)

    const {
        value: nameValue,
        isValid: nameIsValid,
        hasError: nameHasError,
        valueChangeHandler: nameValueChangeHandler,
        inputBlurHandler: nameInputBlurHandler,
        reset: nameReset
    } = useInput(isName)


    const [openErrorDialog, setOpenErrorDialog] = useState("")
    const [openLocationDialog, setOpenLocationDialog] = useState(false)
    const [geolocationFailureRequestCount, setGeolocationFailureRequestCount] = useState(0)

    const documentNumberQueryParam = new URLSearchParams(window.location.search).get('document_number')
    const birthdateQueryParam = new URLSearchParams(window.location.search).get('birthdate')
    const nameQueryParam = new URLSearchParams(window.location.search).get('name')
    const loginHashQueryParam = new URLSearchParams(window.location.search).get('login_hash')

    const resetQueryParams = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('document_number');
        url.searchParams.delete('birthdate');
        url.searchParams.delete('name');
        url.searchParams.delete('login_hash')
        window.history.replaceState({}, document.title, url.toString());
    }

    const collectGeoLocation = useCallback(async () => {
        if (navigator.geolocation) {
            try {
                const position: any = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject)
                })
                return {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                }
            } catch (error) {
                console.log("Error on geolocation retrieval:", error);
                setGeolocationFailureRequestCount(geolocationFailureRequestCount + 1)
                return {
                    latitude: null,
                    longitude: null
                }
            }
        }
    }, [geolocationFailureRequestCount])
    
    const handleSendOTPCode = useCallback(
        async (responseData) => {
            if ((responseData.use_authentication_code && !responseData.skip_initial_notification) && !cookies[`qisign_${signerHash}`]) {
                onSendOTPCode(responseData.signer_token)
            }
        },
        [onSendOTPCode, signerHash, cookies]
    )

    const isValidInputData = useCallback (
        (checkboxChecked = undefined) => {

            if (checkboxChecked !== undefined && checkboxChecked !== null) {
                if (checkboxChecked) {

                    if (cookies[`qisign_${signerHash}`]) {
                        setValidData(true)
                        setOpenErrorDialog("")
                        return true
                    }

                    if (signData.signature_settings.document_number_required) {
    
                        if (!documentNumberIsValid || !birthdateIsValid ) {
                            setOpenErrorDialog("invalid_data")
                            setValidData(false)
                            return false
                        }
            
                    } else {
                        if (!nameIsValid) {
                            setOpenErrorDialog("invalid_data")
                            setValidData(false)
                            return false
                        }
                    }
                    setValidData(true)
                    setOpenErrorDialog("")
                    return true
                }
            }
            else {

                if (cookies[`qisign_${signerHash}`]) {
                    setValidData(true)
                    setOpenErrorDialog("")
                    return true
                }
    
                if (signData.signature_settings.document_number_required) {
    
                    if (!documentNumberQueryParam) {

                        if (!documentNumberIsValid || !birthdateIsValid ) {
                            setOpenErrorDialog("invalid_data")
                            setValidData(false)
                            return false
                        }
            
                        if (!termsCheckboxChecked) {
                            setOpenErrorDialog("terms_not_checked")
                            setValidData(false)
                            return false
                        }
                    }
        
                } else {
                    if (!nameQueryParam) {
                        if (!nameIsValid) {
                            setOpenErrorDialog("invalid_data")
                            setValidData(false)
                            return false
                        }
            
                        if (!termsCheckboxChecked) {
                            setOpenErrorDialog("terms_not_checked")
                            setValidData(false)
                            return false
                        }
                    }
                   
                }
                setValidData(true)
                setOpenErrorDialog("")
                return true
    
            }
    
        }, [birthdateIsValid, documentNumberIsValid, nameIsValid, termsCheckboxChecked, documentNumberQueryParam, nameQueryParam, signData, cookies, signerHash])

    const onSubmit = useCallback(async (documentNumber, birthdate, name, alreadyFormatted, latitude, longitude, browserKey) => {
        
        let payload: any = {}
    
        if (documentNumber) {
            payload["document_number"] = alreadyFormatted
                ? documentNumber
                : cpfMask(documentNumber)
        }

        if (browserKey) {
            payload["device_data"] = {
                "device_key": browserKey
            }
        }

        if (birthdate) {
            payload["birthdate"] = alreadyFormatted
                ? birthdate
                : formatToYYYYMMDD(birthdate)
        }

        if (name !== null && name !== "") {
            payload["name"] = formatName(name)
        }
    
        if (latitude && longitude) {
            payload["gps_data"] = {
                "coordinates": [
                    longitude,
                    latitude
                ]
            }
        }        

        axios.post('/signer/hash/' + signerHash, payload)
            .then(async (response) => {
                const session_id = uuidv4()
                setSignData({ ...signData, ...response.data, session_id })
                await handleSendOTPCode(response.data)
                setOpenLocationDialog(false)
                documentNumberReset()
                birthdateReset()
                nameReset()
                setCookie(`qisign_${signerHash}`, payload, { path: `/s/${signerHash}`, maxAge: 60 * 60 })
                setSignerStep(response.data.next_step)
                setCachedDocumentNumber(payload.document_number)
                setCachedBirthdate(payload.birthdate)
            }).catch((error) => {
                if ([401, 403, 409].includes(error.response?.status)) {
                    setOpenLocationDialog(false)
                    const isSignApiResponse = error?.response?.data?.source === "QI Sign - Sign API"
                    setOpenErrorDialog(isSignApiResponse ? "incorrect_personal_data" : "connection_error")
                }
                setCookie(`qisign_${signerHash}`, '', { path: `/s/${signerHash}`, maxAge: 0 })
                setLoading(false)
            })
            .finally(() => {
                setLoadingForm(false)
            })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setCookie, setSignData, handleSendOTPCode, birthdateReset, documentNumberReset, nameReset, signerHash, signData, setSignerStep])
    

    const executeSubmission = useCallback(
        async(documentNumberQueryParam=undefined, birthdateQueryParam=undefined, nameQueryParam=undefined, alreadyFormatted = false) => {
            
            let browserKey = null;
            try{
                browserKey = await getOrCreateBrowserKey();
            }
            catch(err){
            }
            
            let latitude;
            let longitude;

            if (documentNumberQueryParam) {
                setLoading(true)
                if (signData && signData.signature_settings && !signData.signature_settings?.prevent_geo_location_request && signData.signature_settings?.geo_location_required){
                    let geoLocationData = await collectGeoLocation()
                    latitude = geoLocationData.latitude
                    longitude = geoLocationData.longitude

                    if (!latitude && !longitude) {
                        setLoading(false)
                        setOpenLocationDialog(true)
                        return
                    }
                }

                onSubmit(documentNumberQueryParam, birthdateQueryParam, nameQueryParam, alreadyFormatted, latitude, longitude, browserKey)

            } else {
                let isValidSubmissionData = isValidInputData()
                            
                if (!isValidSubmissionData) {
                    return
                }
                                
                setLoadingForm(true)
                if (!signData.signature_settings.prevent_geo_location_request && signData.signature_settings?.geo_location_required){
                    let geoLocationData = await collectGeoLocation()
                    latitude = geoLocationData.latitude
                    longitude = geoLocationData.longitude

                    if (!latitude && !longitude) {
                        setLoadingForm(false)
                        setOpenLocationDialog(true)
                        return
                    }
                }

                onSubmit(documentNumberValue, birthdateValue, nameValue, alreadyFormatted, latitude, longitude, browserKey)
            }   
            
        }
        ,[signData,documentNumberValue, birthdateValue, nameValue, isValidInputData, collectGeoLocation, onSubmit]) 

    useEffect(() => {
        
        if (hasMadeRequestRef.current) {
            return
        }
    
        hasMadeRequestRef.current = true
    
        if (loginHashQueryParam) {
            if (!signData.signer_data?.document_number) {
                return;
            }
            const handleHashFlow = async () => {
                const keyToInherit = signData.device_data?.device_key ?? null;
                try{
                    await getOrCreateBrowserKey(keyToInherit);
                }
                catch(err){
                }
                executeSubmission(signData.signer_data.document_number, signData.signer_data.birthdate, signData.signer_data.name, true);
                resetQueryParams();
            };
            handleHashFlow();
            return;
        }

        if (documentNumberQueryParam) {
            executeSubmission(documentNumberQueryParam, birthdateQueryParam, nameQueryParam, false)
            resetQueryParams()
            return
        }

        if (cookies[`qisign_${signerHash}`] && isNaturalDocumentNumber(cookies[`qisign_${signerHash}`].document_number)) {
            executeSubmission(cookies[`qisign_${signerHash}`].document_number, cookies[`qisign_${signerHash}`].birthdate, null, true)
        }
    }, [cookies, signerHash, executeSubmission, documentNumberQueryParam, birthdateQueryParam, nameQueryParam, signData.signer_data?.birthdate, signData.signer_data?.name, signData.signer_data?.document_number, loginHashQueryParam, signData.device_data?.device_key])

    const handleLocationDialogClose = () => {
        setOpenLocationDialog(false)
        setLoadingForm(false)
        setLoading(false)
    }

    const handleClick = () => {
        executeSubmission()
    }


    if (loading) {
        return (
            <LoadingPage />
        )
    }

    if (appTheme === 'release') {
        return (
            <S.Container>
                <ClientLogo clientThemeSettings={clientThemeSettings} />
                <S.FormSection
                     onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleKeyDown(e);
                        }
                    }}
                >
                    <S.IntroductionContainer>
                        <S.Title>{signData.signature_settings?.login_content?.title ?? "Login"}</S.Title>
                        <S.Description>{signData.signature_settings?.login_content?.text ?? "Para iniciar o processo de assinatura, preencha os campos abaixo:"}</S.Description>
                    </S.IntroductionContainer>
                    <S.FormFieldContainer>
                        {signData.signature_settings?.document_number_required ?
                            <>
                                <FormField
                                    labelValue={fields.document_number.name}    
                                    onChange={documentNumberValueChangeHandler}
                                    onBlur={documentNumberInputBlurHandler}
                                    hasError={documentNumberHasError}
                                    fieldValue={cpfMask(documentNumberValue)}
                                    errorMessage={fields.document_number.errorMessage}
                                    type="numeric"
                                />
                                <FormField
                                    labelValue={fields.birthdate.name}
                                    onChange={birthdateValueChangeHandler}
                                    onBlur={birthdateInputBlurHandler}
                                    hasError={birthdateHasError}
                                    fieldValue={dateMask(birthdateValue)}
                                    errorMessage={fields.birthdate.errorMessage}
                                    type="numeric"
                                />
                            </> :
                            <>
                                <FormField
                                    labelValue={fields.name.name}
                                    onChange={nameValueChangeHandler}
                                    onBlur={nameInputBlurHandler}
                                    hasError={nameHasError}
                                    fieldValue={nameMask(nameValue)}
                                    errorMessage={fields.name.errorMessage}
                                    type="text"
                                />

                                {signData.signature_settings?.birthdate_required && 
                                    <FormField
                                        labelValue={fields.birthdate.name}
                                        onChange={birthdateValueChangeHandler}
                                        onBlur={birthdateInputBlurHandler}
                                        hasError={birthdateHasError}
                                        fieldValue={dateMask(birthdateValue)}
                                        errorMessage={fields.birthdate.errorMessage}
                                        type="numeric"
                                    />
                                }
                            </>
                        }
                        <S.TermsContainer>
                            <input
                                type='checkbox'
                                value={termsCheckboxChecked as any}
                                onChange={handleTermsCheckboxChange}
                            />
                            <S.Label>
                                Concordo com os <a href="https://sign.qitech.com.br/docs/termos_de_uso.pdf" target="_blank" rel="noreferrer">Termos de Uso</a> e <a href="https://sign.qitech.com.br/docs/politica_de_privacidade.pdf" target="_blank" rel="noreferrer">Política de Privacidade</a>.
                            </S.Label>
                        </S.TermsContainer>
                        <ThemedButton
                            clientThemeSettings={clientThemeSettings}
                            $disabled={!isValidData || loadingForm}
                            $loading={loadingForm}
                            onClick={() => handleClick()}
                        >
                            {loadingForm ? 'Carregando...' : 'Iniciar' }
                        </ThemedButton>
                    </S.FormFieldContainer>
                </S.FormSection>
                <PoweredbByQITech />
                {openLocationDialog && 
                    <LocationDialog
                        open={openLocationDialog}
                        onClose={() => handleLocationDialogClose()}
                        onSubmit={() => handleLocationDialogClose()}
                        geolocationFailureRequestCount={geolocationFailureRequestCount}
                        clientThemeSettings={clientThemeSettings}
                    />
                }
                {openErrorDialog &&
                    <ErrorDialog
                        description={openErrorDialog}
                        onClose={() => setOpenErrorDialog("")}
                        clientThemeSettings={clientThemeSettings}
                    />
                }
            </S.Container>
        )
    }

    return (
        <Wallpaper
            backgroundColor={clientThemeSettings.background_color}
        >
            <div className="base-container base-container-width base-container-padding" 
            style={{ backgroundColor: "rgb(245, 245, 242)" }}
            onKeyDown={handleKeyDown}
            >
                <Logo imageSource={clientThemeSettings.logo_url} />
                <p className="description-level4 gray no-border-container-fullwidth" style={{ textAlign: "justify", marginBottom: '0px'}}>
                    Para iniciar o processo de assinatura, preencha os campos abaixo:
                </p>
                <div className="no-border-container-fullwidth">
                    {signData.signature_settings?.document_number_required === true ?
                     (<>
                        <FormField
                            labelValue={fields.document_number.name}
                            onChange={documentNumberValueChangeHandler}
                            onBlur={documentNumberInputBlurHandler}
                            hasError={documentNumberHasError}
                            fieldValue={cpfMask(documentNumberValue)}
                            errorMessage={fields.document_number.errorMessage}
                            type="numeric"
                        />
                        <FormField
                            labelValue={fields.birthdate.name}
                            onChange={birthdateValueChangeHandler}
                            onBlur={birthdateInputBlurHandler}
                            hasError={birthdateHasError}
                            fieldValue={dateMask(birthdateValue)}
                            errorMessage={fields.birthdate.errorMessage}
                            type="numeric"
                        />
                     
                     </>): 
                     (
                        <FormField
                            labelValue={fields.name.name}
                            onChange={nameValueChangeHandler}
                            onBlur={nameInputBlurHandler}
                            hasError={nameHasError}
                            fieldValue={nameMask(nameValue)}
                            errorMessage={fields.name.errorMessage}
                            type="text"
                        />
                     )
                    }
                    <div className="checkbox-container" style={{marginTop: "12px"}}>
                        <input
                            type="checkbox"
                            id="termsCheckbox"
                            onChange={handleTermsCheckboxChange}
                            checked={termsCheckboxChecked}
                            style={{ transform: 'scale(1.5)', marginRight: '5px' }}

                        />
                        <label htmlFor="termsCheckbox" style={{ marginLeft: '8px', textAlign: 'justify' }}>
                            Concordo com os <a href="https://sign.qitech.com.br/docs/termos_de_uso.pdf" target="_blank" rel="noreferrer">Termos de Uso</a> e <a href="https://sign.qitech.com.br/docs/politica_de_privacidade.pdf" target="_blank" rel="noreferrer">Política de Privacidade</a>.
                        </label>
                    </div>
                    <Button
                        onClick={() => handleClick()}
                        type='primary'
                        disabled={!isValidData || loadingForm}
                        clientThemeSettings={clientThemeSettings}
                    >
                        INICIAR
                    </Button>
                </div>
                <Footer />
            </div>
            {openLocationDialog &&
                <LocationDialog
                    open={openLocationDialog}
                    onClose={() => handleLocationDialogClose()}
                    onSubmit={() => handleLocationDialogClose()}
                    geolocationFailureRequestCount={geolocationFailureRequestCount}
                    clientThemeSettings={clientThemeSettings}
                />}
            {openErrorDialog &&
                <ErrorDialog
                    description={openErrorDialog}
                    onClose={() => setOpenErrorDialog("")}
                    clientThemeSettings={clientThemeSettings}
                />}
        </Wallpaper>
    )
}
